export default __webpack_public_path__ + "static/media/1AFE1F46-8AFB-4A31-B545-8CAD3ED2F62E_1_105_c.f6ae593f.jpeg";